import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.flags";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex'; // 需求：QC 质检工作台-筛选状态保持。列表页筛选条件/页码持久化 key

var FILTER_CACHE_KEY = 'qc-workbench-filter-cache';
export default {
  name: 'question-bank-qc',
  data: function data() {
    return {
      loading: false,
      batchPassing: false,
      query: {
        keyword: '',
        questionTypeId: '',
        skillDimension: '',
        qcStatus: '',
        flag: '',
        grade: '',
        book: '',
        unit: '',
        onlyFlagged: false,
        id: undefined
      },
      cards: [],
      selectedIds: [],
      pagination: {
        current: 1,
        size: 12,
        total: 0
      },
      stats: {
        total: 0,
        pending: 0,
        pass: 0,
        fail: 0,
        flagged: 0,
        flagCounts: {}
      },
      flagMetas: [],
      rejectReasons: [],
      rejectDialog: {
        visible: false,
        question: null,
        reasons: [],
        note: '',
        saving: false
      },
      flagConfirm: {
        visible: false,
        question: null,
        flags: []
      },
      gradeOptions: [{
        value: 'grade3',
        label: '三年级'
      }, {
        value: 'grade4',
        label: '四年级'
      }, {
        value: 'grade5',
        label: '五年级'
      }, {
        value: 'grade6',
        label: '六年级'
      }],
      bookOptions: [{
        value: 'up',
        label: '上册'
      }, {
        value: 'down',
        label: '下册'
      }],
      unitFilterOptions: [],
      firstRender: true,
      // 音频播放器状态：加载的是哪道题的音频 + 当前是否在播放
      audioQuestionId: null,
      audioPlaying: false
    };
  },
  computed: {
    // 可批量通过的题目：无旗标且已勾选
    passableSelected: function passableSelected() {
      var _this = this;

      return this.cards.filter(function (c) {
        return _this.selectedIds.includes(c.id) && !_this.hasFlag(c);
      });
    },
    flagMetaMap: function flagMetaMap() {
      var map = {};
      this.flagMetas.forEach(function (f) {
        map[f.code] = f;
      });
      return map;
    },
    rejectReasonMap: function rejectReasonMap() {
      var map = {};
      this.rejectReasons.forEach(function (r) {
        map[r.code] = r;
      });
      return map;
    }
  },
  mounted: function mounted() {
    document.addEventListener('keydown', this.handleKeydown);
    this.loadDict(); // 从题库列表「质检」入口跳转过来时，路由带 id，优先按 id 定位

    var routeId = this.routeQuestionId();

    if (routeId) {
      this.query.id = routeId;
      this.pagination.current = 1;
      this.loadData();
      return;
    }

    if (!this.restoreFilterCache()) {
      this.loadData();
    }
  },
  activated: function activated() {
    if (this.firstRender) {
      this.firstRender = false;
      return;
    }

    var routeId = this.routeQuestionId();

    if (routeId && routeId !== this.query.id) {
      this.query.id = routeId;
      this.pagination.current = 1;
    }

    this.loadData();
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
    this.stopAudio();
  },
  // keep-alive 缓存页：切走时不会触发 beforeDestroy，需单独停音频，避免离开后仍在响
  deactivated: function deactivated() {
    this.stopAudio();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['close'])), {}, {
    // 离开页面时停止音频播放
    stopAudio: function stopAudio() {
      var player = this.$refs.qcAudioPlayer;
      if (player) player.pause();
      this.audioPlaying = false;
    },
    // 字典（旗标元数据 / 驳回原因码）
    loadDict: function loadDict() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var flags, reasons;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this2.$api.getQcFlagMetas();

              case 3:
                flags = _context.sent;
                _this2.flagMetas = flags || [];
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                _this2.flagMetas = [];

              case 10:
                _context.prev = 10;
                _context.next = 13;
                return _this2.$api.getQcRejectReasons();

              case 13:
                reasons = _context.sent;
                _this2.rejectReasons = reasons || [];
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t1 = _context["catch"](10);
                _this2.rejectReasons = [];

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7], [10, 17]]);
      }))();
    },
    loadData: function loadData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loading = true;

                _this3.saveFilterCache();

                _this3.stopAudio();

                _context2.prev = 3;
                params = {
                  page: _this3.pagination.current - 1,
                  size: _this3.pagination.size
                };
                Object.keys(_this3.query).forEach(function (k) {
                  var v = _this3.query[k];

                  if (v !== '' && v !== null && v !== undefined && v !== false) {
                    params[k] = v;
                  }
                });
                _context2.next = 8;
                return _this3.$api.loadQcQuestionList(params);

              case 8:
                res = _context2.sent;
                _this3.cards = res && res.content || [];
                _this3.pagination.total = res && res.totalElements || 0;
                _this3.selectedIds = _this3.selectedIds.filter(function (id) {
                  return _this3.cards.some(function (c) {
                    return c.id === id;
                  });
                });
                _context2.next = 14;
                return _this3.loadStats();

              case 14:
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](3);

                _this3.$message.error('加载质检列表失败');

              case 19:
                _context2.prev = 19;
                _this3.loading = false;
                return _context2.finish(19);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 16, 19, 22]]);
      }))();
    },
    loadStats: function loadStats() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var st;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this4.$api.getQcStats();

              case 3:
                st = _context3.sent;
                _this4.stats = st || _this4.stats;
                _context3.next = 9;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 7]]);
      }))();
    },
    // 筛选状态保持
    saveFilterCache: function saveFilterCache() {
      try {
        sessionStorage.setItem(FILTER_CACHE_KEY, JSON.stringify({
          query: this.query,
          current: this.pagination.current,
          size: this.pagination.size
        }));
      } catch (e) {
        /* 存储异常不影响主流程 */
      }
    },
    restoreFilterCache: function restoreFilterCache() {
      try {
        var raw = sessionStorage.getItem(FILTER_CACHE_KEY);
        if (!raw) return false;
        var cache = JSON.parse(raw);

        if (cache && cache.query) {
          this.query = _objectSpread(_objectSpread({}, this.query), cache.query);
          this.pagination.current = cache.current || 1;
          this.pagination.size = cache.size || this.pagination.size;

          if (this.query.grade && this.query.book) {
            this.loadUnitFilterOptions();
            return true;
          }
        }
      } catch (e) {
        /* 解析异常按无缓存处理 */
      }

      return false;
    },
    handleSearch: function handleSearch() {
      this.pagination.current = 1;
      this.loadData();
    },
    handleResetFilter: function handleResetFilter() {
      this.query = {
        keyword: '',
        questionTypeId: '',
        skillDimension: '',
        qcStatus: '',
        flag: '',
        grade: '',
        book: '',
        unit: '',
        onlyFlagged: false,
        id: undefined
      };
      this.unitFilterOptions = [];
      this.pagination.current = 1;
      this.loadData();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pagination.size = size;
      this.loadData();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.pagination.current = page;
      this.loadData();
    },
    handleGradeChange: function handleGradeChange() {
      this.query.unit = '';
      this.unitFilterOptions = [];

      if (this.query.grade && this.query.book) {
        this.loadUnitFilterOptions();
      } else {
        this.loadData();
      }
    },
    handleBookChange: function handleBookChange() {
      this.query.unit = '';
      this.unitFilterOptions = [];

      if (this.query.grade && this.query.book) {
        this.loadUnitFilterOptions();
      } else {
        this.loadData();
      }
    },
    loadUnitFilterOptions: function loadUnitFilterOptions() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res, overview, units;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _this5.$api.getKgOverview(_this5.query.grade, _this5.query.book);

              case 3:
                res = _context4.sent;
                overview = res && res.data ? res.data : res;
                units = overview && overview.units ? overview.units : [];
                _this5.unitFilterOptions = units.map(function (u) {
                  return {
                    code: u.code,
                    name: (u.name_en ? u.name_en + ' ' : '') + (u.theme_cn ? u.theme_cn : '')
                  };
                });

                _this5.loadData();

                _context4.next = 14;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                _this5.unitFilterOptions = [];

                _this5.loadData();

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 10]]);
      }))();
    },
    // ---- 裁定 ----
    hasFlag: function hasFlag(card) {
      return !!(card.flags && card.flags.length);
    },
    toggleSelect: function toggleSelect(id, checked) {
      var idx = this.selectedIds.indexOf(id);

      if (checked && idx === -1) {
        this.selectedIds.push(id);
      } else if (!checked && idx > -1) {
        this.selectedIds.splice(idx, 1);
      }
    },
    handlePass: function handlePass(card) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!_this6.hasFlag(card)) {
                  _context5.next = 3;
                  break;
                }

                // 带旗标题需二次确认
                _this6.flagConfirm = {
                  visible: true,
                  question: card,
                  flags: card.flagDetails
                };
                return _context5.abrupt("return");

              case 3:
                _context5.next = 5;
                return _this6.doDecide(card, {
                  qcStatus: 'pass',
                  qcNote: '',
                  rejectReasonCodes: []
                });

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    confirmPassWithFlag: function confirmPassWithFlag() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var card;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                card = _this7.flagConfirm.question;
                _this7.flagConfirm.visible = false;

                if (!card) {
                  _context6.next = 5;
                  break;
                }

                _context6.next = 5;
                return _this7.doDecide(card, {
                  qcStatus: 'pass',
                  qcNote: '',
                  rejectReasonCodes: []
                });

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    openReject: function openReject(card) {
      this.rejectDialog = {
        visible: true,
        question: card,
        reasons: [],
        note: '',
        saving: false
      };
    },
    submitReject: function submitReject() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var d;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                d = _this8.rejectDialog;

                if (d.reasons.length) {
                  _context7.next = 4;
                  break;
                }

                _this8.$message.warning('请至少选择一个驳回原因');

                return _context7.abrupt("return");

              case 4:
                if (!(!d.note || d.note.trim().length < 5)) {
                  _context7.next = 7;
                  break;
                }

                _this8.$message.warning('驳回备注不少于 5 个字');

                return _context7.abrupt("return");

              case 7:
                d.saving = true;
                _context7.prev = 8;
                _context7.next = 11;
                return _this8.doDecide(d.question, {
                  qcStatus: 'fail',
                  qcNote: d.note.trim(),
                  rejectReasonCodes: d.reasons
                });

              case 11:
                d.visible = false;

              case 12:
                _context7.prev = 12;
                d.saving = false;
                return _context7.finish(12);

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[8,, 12, 15]]);
      }))();
    },
    doDecide: function doDecide(card, payload) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res, statusText;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return _this9.$api.submitQcDecision(card.id, payload);

              case 3:
                res = _context8.sent;

                if (res) {
                  _context8.next = 6;
                  break;
                }

                return _context8.abrupt("return");

              case 6:
                statusText = res.questionStatus ? '，题目状态：' + _this9.statusLabel(res.questionStatus) : '';

                _this9.$message.success('已记录质检结论：' + _this9.qcStatusLabel(res.qcStatus) + statusText + '（通过即上架）');

                _context8.next = 10;
                return _this9.loadData();

              case 10:
                _context8.next = 15;
                break;

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8["catch"](0);

                _this9.$message.error('提交质检结论失败');

              case 15:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 12]]);
      }))();
    },
    handleBatchPass: function handleBatchPass() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var ids, res, passed, rejected;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                ids = _this10.passableSelected.map(function (c) {
                  return c.id;
                });

                if (ids.length) {
                  _context9.next = 3;
                  break;
                }

                return _context9.abrupt("return");

              case 3:
                _this10.batchPassing = true;
                _context9.prev = 4;
                _context9.next = 7;
                return _this10.$api.batchPassQcQuestions(ids);

              case 7:
                res = _context9.sent;
                passed = res && res.passed || [];
                rejected = res && res.rejected || [];

                if (rejected.length) {
                  _this10.$message.warning("\u5DF2\u901A\u8FC7 ".concat(passed.length, " \u9053\uFF1B").concat(rejected.length, " \u9053\u5E26\u65D7\u6807\u88AB\u62D2\u7EDD\uFF1A").concat(rejected.map(function (r) {
                    return '#' + r.id;
                  }).join('、')));
                } else {
                  _this10.$message.success("\u5DF2\u6279\u91CF\u901A\u8FC7 ".concat(passed.length, " \u9053\u9898\u76EE"));
                }

                _this10.selectedIds = [];
                _context9.next = 14;
                return _this10.loadData();

              case 14:
                _context9.next = 19;
                break;

              case 16:
                _context9.prev = 16;
                _context9.t0 = _context9["catch"](4);

                _this10.$message.error('批量通过失败');

              case 19:
                _context9.prev = 19;
                _this10.batchPassing = false;
                return _context9.finish(19);

              case 22:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[4, 16, 19, 22]]);
      }))();
    },
    handleEdit: function handleEdit(card) {
      this.$router.push({
        name: 'question-bank-edit',
        params: {
          id: card.id
        }
      });
    },
    previewPic: function previewPic(url) {
      window.open(url, '_blank');
    },
    // ---- 音频试听 ----
    isPlaying: function isPlaying(questionId) {
      return this.audioQuestionId === questionId && this.audioPlaying;
    },
    toggleAudio: function toggleAudio(card) {
      var _this11 = this;

      var player = this.$refs.qcAudioPlayer;
      if (!player || !card.audio) return;

      if (this.isPlaying(card.id)) {
        player.pause();
        this.audioPlaying = false;
        return;
      } // 换源前先停止当前音频；换源引发的 pause 事件不参与状态判定，状态由本方法显式维护


      player.pause();

      if (this.audioQuestionId !== card.id) {
        player.src = card.audio;
        this.audioQuestionId = card.id;
      } // 上一轮播完后再次点击，从头播放


      if (player.ended) player.currentTime = 0;
      this.audioPlaying = true;
      var p = player.play();

      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          _this11.audioPlaying = false;

          _this11.$message.error('音频播放失败，请检查URL是否有效');
        });
      }
    },
    onAudioPlay: function onAudioPlay() {
      this.audioPlaying = true;
    },
    onAudioEnded: function onAudioEnded() {
      this.audioPlaying = false;
    },
    onAudioError: function onAudioError() {
      this.audioPlaying = false;
      this.$message.error('音频加载失败，请检查URL是否有效');
    },
    // ---- 展示辅助 ----
    cardClass: function cardClass(card) {
      if (card.qcStatus === 'pass') return 'qc-card--pass';
      if (card.qcStatus === 'fail') return 'qc-card--fail';
      if (this.hasFlag(card)) return 'qc-card--flag';
      return '';
    },
    // 单选/多选题：按答案字母定位正确选项；排序题答案为字母排列，不做单项高亮
    isCorrectOption: function isCorrectOption(card, index) {
      if (card.questionTypeId !== 1 && card.questionTypeId !== 6) return false;
      if (!card.answerIsLetterSequence) return false;
      var letters = String(card.correctAnswer || '').split('|').map(function (s) {
        return s.trim().toUpperCase();
      });
      var target = String.fromCharCode(65 + index);
      return letters.includes(target);
    },
    optionLetter: function optionLetter(card, index) {
      if (card.questionTypeId === 1 || card.questionTypeId === 6) {
        return String.fromCharCode(65 + index);
      }

      return index + 1 + '.';
    },
    audioFileName: function audioFileName(url) {
      if (!url) return ''; // 去掉版本查询串（?v=YYYYMMDD），仅展示文件名

      var clean = String(url).split('?')[0];
      var parts = clean.split('/');
      return parts[parts.length - 1] || clean;
    },
    rejectReasonLabel: function rejectReasonLabel(codes) {
      var _this12 = this;

      return (codes || []).map(function (c) {
        return _this12.rejectReasonMap[c] ? _this12.rejectReasonMap[c].label : c;
      }).join('、');
    },
    questionTypeLabel: function questionTypeLabel(id) {
      var map = {
        1: '单选',
        2: '连线',
        3: '排序',
        4: '简答',
        5: '长文本',
        6: '多选'
      };
      return map[id] || '未设置';
    },
    dimensionLabel: function dimensionLabel(dim) {
      // 需求ID: REQ-20261029-VIEWING — 技能维度 5 值，与 list.vue 保持一致
      var map = {
        listening: '听力',
        reading: '阅读',
        viewing: '看',
        writing: '写作',
        comprehensive: '综合'
      };
      return map[dim] || dim || 'N/A';
    },
    dimensionTagType: function dimensionTagType(dim) {
      var map = {
        listening: '',
        reading: 'success',
        viewing: 'info',
        writing: 'warning',
        comprehensive: 'primary'
      };
      return map[dim] || 'info';
    },
    strategyTagType: function strategyTagType(s) {
      var map = {
        exact: 'info',
        bilingual: '',
        structural: '',
        semantic_vector: '',
        intent: '',
        multi_dimension: 'warning'
      };
      return map[s] || 'danger';
    },
    statusLabel: function statusLabel(status) {
      // 题目状态仅两态：草稿 / 已发布（质检结论另走 qcStatusLabel）
      var map = {
        draft: '草稿',
        published: '已发布'
      };
      return map[status] || status || 'N/A';
    },
    statusTagType: function statusTagType(status) {
      // 题目状态仅两态：草稿 / 已发布
      var map = {
        draft: 'info',
        published: 'success'
      };
      return map[status] || 'info';
    },
    qcStatusLabel: function qcStatusLabel(s) {
      var map = {
        pending: '待检',
        pass: '已通过',
        fail: '已驳回'
      };
      return map[s] || '待检';
    },
    qcStatusTagType: function qcStatusTagType(s) {
      var map = {
        pending: 'info',
        pass: 'success',
        fail: 'danger'
      };
      return map[s] || 'info';
    },
    // 知识点所属年级/册/单元（kg_nodes.grade_code / book_code / unit），用于卡片上快速定位归属
    nodeScopeText: function nodeScopeText(b) {
      if (!b) return '';
      var gradeMap = {
        grade3: '三年级',
        grade4: '四年级',
        grade5: '五年级',
        grade6: '六年级'
      };
      var bookMap = {
        up: '上册',
        down: '下册'
      };
      return [gradeMap[b.gradeCode] || b.gradeCode || '', bookMap[b.bookCode] || b.bookCode || '', b.unit || ''].filter(Boolean).join(' ');
    },
    flagTagType: function flagTagType(code) {
      var map = {
        L: 'danger',
        D1: 'danger',
        D2: 'warning',
        A: 'warning',
        S: 'danger',
        S2: 'danger'
      };
      return map[code] || 'info';
    },
    bloomLabel: function bloomLabel(level) {
      var map = {
        记忆: '记忆',
        理解: '理解',
        应用: '应用',
        分析: '分析',
        评价: '评价',
        创造: '创造',
        remember: '记忆',
        understand: '理解',
        apply: '应用',
        analyze: '分析',
        evaluate: '评价',
        create: '创造'
      };
      return map[level] || level || 'N/A';
    },
    // ---- 路由定位 ----
    routeQuestionId: function routeQuestionId() {
      var raw = this.$route && this.$route.query && this.$route.query.id || '';
      var num = Number(raw);
      return raw && !isNaN(num) && num > 0 ? num : null;
    },
    // ---- 快捷键 ----
    handleKeydown: function handleKeydown(e) {
      var tag = e.target && e.target.tagName || '';
      if (['INPUT', 'TEXTAREA', 'SELECT'].includes(tag)) return;

      if (e.key === 'r' || e.key === 'R') {
        this.loadData();
      } else if (e.key === 'j' || e.key === 'J') {
        this.moveFocus(1);
      } else if (e.key === 'k' || e.key === 'K') {
        this.moveFocus(-1);
      }
    },
    moveFocus: function moveFocus(delta) {
      var el = document.querySelector('.qc-card');
      if (!el) return;
      var all = Array.prototype.slice.call(document.querySelectorAll('.qc-card'));
      var idx = all.indexOf(el);
      var next = all[idx + delta];
      if (next) next.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  })
};